// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3zAqn","inputWrap":"CustomTip_inputWrap__saXTS"};